(function () {
  if (window.__mpProductInit) return;
  window.__mpProductInit = true;

  /* iOS Safari zooms the page when a focused input has a *computed*
     font-size under 16px. Customily's own stylesheet can win the CSS
     cascade against ours (more specific selector + !important), so force
     it with an inline style at focus time instead — inline style always
     wins over any external stylesheet. */
  document.addEventListener('focusin', function (event) {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var field = event.target.closest('input, textarea, select');
    if (!field) return;
    if (!field.closest('#customily-options, [id*="customily" i], [class*="customily" i]')) return;
    field.style.setProperty('font-size', '17px', 'important');
  });

  /* Keep the variant picker on a combination that actually exists.

     Option matrices here are sparse: a "Complete Look Set" offers
     Without Box / With Box for the cap but S–6XL for the hoodie. Dawn leaves
     every other option untouched when one changes, so switching Type while
     "Without Box" is selected asks the server for a variant that does not
     exist — the picker then shows an unavailable value as selected and the
     price falls back to an unrelated variant.

     Repair the selection during the capture phase, before <variant-selects>
     publishes the change, so Dawn ends up requesting a real variant. */
  function mpOptionGroupValue(group) {
    var dropdown = group.querySelector('select');
    if (dropdown) return dropdown.value;
    var checked = group.querySelector("input[type='radio']:checked");
    return checked ? checked.value : null;
  }

  function mpSetOptionGroupValue(group, name) {
    var dropdown = group.querySelector('select');

    if (dropdown) {
      var match = null;
      Array.prototype.forEach.call(dropdown.options, function (option) {
        if (option.value === name) match = option;
      });
      if (!match) return false;
      var previous = dropdown.querySelector('option[selected]');
      if (previous) previous.removeAttribute('selected');
      match.setAttribute('selected', 'selected');
      dropdown.value = name;
    } else {
      var radio = null;
      group.querySelectorAll("input[type='radio']").forEach(function (input) {
        if (input.value === name) radio = input;
      });
      if (!radio) return false;
      radio.checked = true;
    }

    /* Dawn only refreshes the label of the option the shopper touched, so
       keep the ones we moved in sync until the section re-renders. */
    var label = group.querySelector('[data-selected-value]');
    if (label) label.textContent = name;
    return true;
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || (input.tagName !== 'SELECT' && input.type !== 'radio')) return;

      var root = input.closest('variant-selects');
      if (!root) return;

      var payload = root.querySelector('[data-variant-matrix]');
      if (!payload) return;

      var matrix;
      try {
        matrix = JSON.parse(payload.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(matrix) || !matrix.length) return;

      var groups = Array.prototype.slice.call(root.querySelectorAll('.product-form__input'));
      if (groups.length < 2) return;

      var changed = groups.indexOf(input.closest('.product-form__input'));
      if (changed < 0) return;

      var current = groups.map(mpOptionGroupValue);
      if (current.indexOf(null) > -1) return;

      var exists = matrix.some(function (combo) {
        return combo.length === current.length && combo.every(function (name, i) { return name === current[i]; });
      });
      if (exists) return;

      /* Honour what the shopper just picked, then keep as much of the rest
         of their selection as the catalogue allows. */
      var best = null;
      var bestScore = -1;
      matrix.forEach(function (combo) {
        if (combo.length !== current.length || combo[changed] !== current[changed]) return;
        var score = 0;
        for (var i = 0; i < combo.length; i++) {
          if (i !== changed && combo[i] === current[i]) score++;
        }
        if (score > bestScore) {
          bestScore = score;
          best = combo;
        }
      });
      if (!best) return;

      groups.forEach(function (group, i) {
        if (i !== changed) mpSetOptionGroupValue(group, best[i]);
      });
    },
    true
  );

  document.querySelectorAll('[data-mp-countdown]').forEach(function (timer) {
    var duration = Number(timer.getAttribute('data-duration-seconds')) || 10800;
    var cooldown = Number(timer.getAttribute('data-cooldown-seconds')) || 21600;
    var key = timer.getAttribute('data-storage-key') || 'mp-flash-sale';
    var now = Date.now();
    var stored = {};

    try {
      stored = JSON.parse(localStorage.getItem(key) || '{}');
    } catch (error) {
      stored = {};
    }

    if (!stored.endsAt || now > Number(stored.endsAt) + cooldown * 1000) {
      stored.endsAt = now + duration * 1000;
      try {
        localStorage.setItem(key, JSON.stringify(stored));
      } catch (error) {}
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function render() {
      var remaining = Math.max(0, Math.floor((Number(stored.endsAt) - Date.now()) / 1000));
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      timer.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    render();
    setInterval(render, 1000);
  });

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  document.querySelectorAll('[data-mp-location-selector]').forEach(function (selector) {
    var toggle = selector.querySelector('[data-mp-location-toggle]');
    var name = selector.querySelector('[data-mp-location-name]');
    var flag = selector.querySelector('[data-mp-location-flag]');
    var deliveryChip = selector.querySelector('.mp-product-delivery-chip');
    if (!toggle || !name || !flag) return;

    var countries = [
      ['United States', '🇺🇸'],
      ['Canada', '🇨🇦'],
      ['United Kingdom', '🇬🇧'], ['Germany', '🇩🇪'], ['France', '🇫🇷'], ['Italy', '🇮🇹'],
      ['Spain', '🇪🇸'], ['Netherlands', '🇳🇱'], ['Ireland', '🇮🇪'], ['Sweden', '🇸🇪'],
      ['Norway', '🇳🇴'], ['Denmark', '🇩🇰'], ['Switzerland', '🇨🇭'], ['Belgium', '🇧🇪'],
      ['Austria', '🇦🇹'], ['Portugal', '🇵🇹'], ['Poland', '🇵🇱'], ['Czech Republic', '🇨🇿'],
      ['Hungary', '🇭🇺'], ['Romania', '🇷🇴'], ['Greece', '🇬🇷'], ['Finland', '🇫🇮'],
      ['Australia', '🇦🇺'], ['New Zealand', '🇳🇿'],
      ['Mexico', '🇲🇽'], ['Guatemala', '🇬🇹'], ['Costa Rica', '🇨🇷'], ['Panama', '🇵🇦'],
      ['Brazil', '🇧🇷'], ['Argentina', '🇦🇷'], ['Colombia', '🇨🇴'], ['Chile', '🇨🇱'],
      ['Peru', '🇵🇪'], ['Venezuela', '🇻🇪'], ['Ecuador', '🇪🇨'],
      ['Japan', '🇯🇵'], ['South Korea', '🇰🇷'], ['Singapore', '🇸🇬'], ['China', '🇨🇳'],
      ['Hong Kong', '🇭🇰'], ['Taiwan', '🇹🇼'], ['Thailand', '🇹🇭'], ['Vietnam', '🇻🇳'],
      ['Indonesia', '🇮🇩'], ['Philippines', '🇵🇭'], ['Malaysia', '🇲🇾'], ['India', '🇮🇳'],
      ['United Arab Emirates', '🇦🇪'], ['Saudi Arabia', '🇸🇦'], ['Israel', '🇮🇱'],
      ['South Africa', '🇿🇦']
    ];
    /* Single source of truth for delivery estimates: [min, max] total days
       from order to delivery. Box 1 (this chip) and Box 2 (the timeline
       below it, .mp-product-delivery-box) both read from this same map so
       they can never show two different numbers for the same country. */
    var deliveryByCountry = {
      'United States': [8, 10],
      'Canada': [15, 40],
      'United Kingdom': [15, 40],
      'Germany': [15, 40],
      'France': [15, 40],
      'Italy': [15, 40],
      'Spain': [15, 40],
      'Netherlands': [15, 40],
      'Ireland': [15, 40],
      'Sweden': [15, 40],
      'Norway': [15, 40],
      'Denmark': [15, 40],
      'Switzerland': [15, 40],
      'Belgium': [15, 40],
      'Austria': [15, 40],
      'Portugal': [15, 40],
      'Poland': [15, 40],
      'Czech Republic': [15, 40],
      'Hungary': [15, 40],
      'Romania': [15, 40],
      'Greece': [15, 40],
      'Finland': [15, 40],
      'Australia': [15, 45],
      'New Zealand': [15, 45],
      'Mexico': [20, 60],
      'Guatemala': [20, 60],
      'Costa Rica': [20, 60],
      'Panama': [20, 60],
      'Brazil': [20, 60],
      'Argentina': [20, 60],
      'Colombia': [20, 60],
      'Chile': [20, 60],
      'Peru': [20, 60],
      'Venezuela': [20, 60],
      'Ecuador': [20, 60],
      'Japan': [20, 40],
      'South Korea': [20, 40],
      'Singapore': [20, 40],
      'China': [20, 40],
      'Hong Kong': [20, 40],
      'Taiwan': [20, 40],
      'Thailand': [20, 40],
      'Vietnam': [20, 40],
      'Indonesia': [20, 40],
      'Philippines': [20, 40],
      'Malaysia': [20, 40],
      'India': [20, 40],
      'United Arab Emirates': [20, 40],
      'Saudi Arabia': [20, 40],
      'Israel': [20, 40],
      'South Africa': [20, 60]
    };
    var DEFAULT_RANGE = [15, 40];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function getRange(countryName) {
      return deliveryByCountry[countryName] || DEFAULT_RANGE;
    }

    function formatRangeText(range) {
      return range[0] + '-' + range[1] + ' days';
    }

    function addDays(date, days) {
      var result = new Date(date.getTime());
      result.setDate(result.getDate() + days);
      return result;
    }

    function formatShortDate(date) {
      return MONTHS[date.getMonth()] + ' ' + date.getDate();
    }

    function updateDeliveryText(countryName) {
      if (!deliveryChip) return;
      var datesText = deliveryChip.querySelector('[data-mp-delivery-dates-text]');
      if (!datesText) return;
      var range = getRange(countryName);
      var today = new Date();
      datesText.textContent = formatShortDate(addDays(today, range[0])) + '–' + formatShortDate(addDays(today, range[1]));
    }

    function escapeHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function ensureDeliveryPopup() {
      var existing = document.querySelector('.mp-delivery-popup');
      if (existing) return existing;

      var dataEl = selector.querySelector('.mp-dc-popup-data');
      var notesEl = dataEl && dataEl.querySelector('.mp-dc-popup-data__notes');
      var labelPlaced    = (dataEl && dataEl.getAttribute('data-dc-label-placed'))    || 'Order Placed:';
      var labelShips     = (dataEl && dataEl.getAttribute('data-dc-label-ships'))     || 'Order Ships:';
      var labelDelivered = (dataEl && dataEl.getAttribute('data-dc-label-delivered')) || 'Delivered:';
      var notesHtml      = notesEl ? notesEl.innerHTML : '';

      var popup = document.createElement('div');
      popup.className = 'mp-delivery-popup';
      popup.hidden = true;
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('aria-label', 'Delivery Method');
      popup.innerHTML = [
        '<button class="mp-delivery-popup__overlay" type="button" data-dc-close aria-label="Close"></button>',
        '<div class="mp-delivery-popup__panel">',
          '<button class="mp-delivery-popup__x" type="button" data-dc-close aria-label="Close">',
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
          '</button>',
          '<h2 class="mp-delivery-popup__title">',
            '<svg class="mp-delivery-popup__title-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">',
              '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
              '<circle cx="7" cy="18" r="1.5" stroke="currentColor" stroke-width="1.8"/>',
              '<circle cx="17" cy="18" r="1.5" stroke="currentColor" stroke-width="1.8"/>',
            '</svg>',
            'Delivery Method',
          '</h2>',
          '<p class="mp-delivery-popup__subtitle">Standard Shipping</p>',
          '<table class="mp-delivery-popup__table"><tbody>',
            '<tr><td>' + escapeHtml(labelPlaced)    + '</td><td><strong data-dc-popup-placed></strong></td></tr>',
            '<tr><td>' + escapeHtml(labelShips)     + '</td><td><strong data-dc-popup-ships></strong></td></tr>',
            '<tr><td>' + escapeHtml(labelDelivered) + '</td><td><strong data-dc-popup-delivered></strong></td></tr>',
          '</tbody></table>',
          notesHtml ? ('<hr class="mp-delivery-popup__hr"><div class="mp-delivery-popup__notes">' + notesHtml + '</div>') : '',
        '</div>'
      ].join('');

      document.body.appendChild(popup);
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-dc-close]')) closeDeliveryPopup(popup);
      });
      return popup;
    }

    function closeDeliveryPopup(popup) {
      popup.classList.remove('is-open');
      setTimeout(function () { popup.hidden = true; }, 280);
    }

    function openDeliveryPopup(countryName) {
      var popup = ensureDeliveryPopup();
      var range = getRange(countryName);
      var today = new Date();
      var prodMin = parseInt(selector.getAttribute('data-dc-prod-min'), 10) || 3;
      var prodMax = parseInt(selector.getAttribute('data-dc-prod-max'), 10) || 5;

      var placedEl    = popup.querySelector('[data-dc-popup-placed]');
      var shipsEl     = popup.querySelector('[data-dc-popup-ships]');
      var deliveredEl = popup.querySelector('[data-dc-popup-delivered]');

      if (placedEl)    placedEl.textContent    = formatShortDate(today);
      if (shipsEl)     shipsEl.textContent     = formatShortDate(addDays(today, prodMin)) + '–' + formatShortDate(addDays(today, prodMax));
      if (deliveredEl) deliveredEl.textContent = formatShortDate(addDays(today, range[0])) + '–' + formatShortDate(addDays(today, range[1]));

      popup.hidden = false;
      window.requestAnimationFrame(function () { popup.classList.add('is-open'); });
    }

    /* Keep Box 2 (the order-placed / ships / delivered timeline) in sync
       with whatever country is selected in Box 1 above it. */
    function updateDeliveryBox(countryName) {
      var box = selector.closest('.product__info-container');
      box = box && box.querySelector('[data-mp-delivery-box]');
      if (!box) return;

      var range = getRange(countryName);
      var productionDays = parseInt(box.getAttribute('data-mp-production-days'), 10) || 1;
      var today = new Date();

      var shipsEl = box.querySelector('.mp-product-delivery-timeline__date--ships');
      var deliveredEl = box.querySelector('.mp-product-delivery-timeline__date--delivered');
      if (shipsEl) shipsEl.textContent = formatShortDate(addDays(today, productionDays));
      if (deliveredEl) {
        deliveredEl.textContent = formatShortDate(addDays(today, range[0])) + '-' + formatShortDate(addDays(today, range[1]));
      }

      var disclaimerEl = box.querySelector('[data-mp-disclaimer-text]');
      if (disclaimerEl) {
        disclaimerEl.textContent = countryName === 'United States'
          ? box.getAttribute('data-mp-disclaimer-us')
          : 'International estimates are approximate and may vary with customs.';
      }
    }

    /* Sync Box 2 and chip to whatever country Box 1 shows by default, on first paint. */
    updateDeliveryBox(name.textContent.trim() || 'United States');
    updateDeliveryText(name.textContent.trim() || 'United States');

    function ensureModal() {
      var modal = document.querySelector('.mp-location-modal');
      if (modal) return modal;

      modal = document.createElement('div');
      modal.className = 'mp-location-modal';
      modal.hidden = true;
      modal.innerHTML = [
        '<button class="mp-location-modal__overlay" type="button" data-mp-location-close aria-label="Close country selector"></button>',
        '<form class="mp-location-modal__panel" data-mp-location-form>',
          '<button class="mp-location-modal__close" type="button" data-mp-location-close aria-label="Close">×</button>',
          '<h2>Select your shipping country</h2>',
          '<label for="mp-location-country">Country</label>',
          '<select id="mp-location-country" data-mp-location-select></select>',
          '<button class="mp-location-modal__submit" type="submit">Submit</button>',
        '</form>'
      ].join('');
      document.body.appendChild(modal);

      var select = modal.querySelector('[data-mp-location-select]');
      select.innerHTML = countries.map(function (country) {
        return '<option value="' + country[0] + '" data-flag="' + country[1] + '">' + country[1] + ' ' + country[0] + '</option>';
      }).join('');

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-mp-location-close]')) closeModal(modal);
      });

      modal.querySelector('[data-mp-location-form]').addEventListener('submit', function (event) {
        event.preventDefault();
        var option = select.options[select.selectedIndex];
        name.textContent = option.value;
        flag.textContent = option.getAttribute('data-flag') || '🇺🇸';
        updateDeliveryText(option.value);
        updateDeliveryBox(option.value);
        closeModal(modal);
      });

      return modal;
    }

    function closeModal(modal) {
      modal.hidden = true;
      modal.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var modal = ensureModal();
      var select = modal.querySelector('[data-mp-location-select]');
      if (select) select.value = name.textContent.trim() || 'United States';
      modal.hidden = false;
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
    });

    var datesBtn = deliveryChip && deliveryChip.querySelector('[data-mp-delivery-dates]');
    if (datesBtn) {
      datesBtn.addEventListener('click', function () {
        openDeliveryPopup(name.textContent.trim() || 'United States');
      });
    }
  });

  document.querySelectorAll('[data-mp-bundle]').forEach(function (bundle) {
    var total = bundle.querySelector('[data-mp-bundle-total]');
    var wasPrice = bundle.querySelector('[data-mp-bundle-was]');
    var saving = bundle.querySelector('[data-mp-bundle-saving]');
    var addButton = bundle.querySelector('[data-mp-bundle-add]');
    var addLabel = addButton ? addButton.textContent.trim() : '';
    var inputs = Array.from(bundle.querySelectorAll('.mp-product-bundle__input'));
    var items = Array.from(bundle.querySelectorAll('[data-mp-bundle-item]'));
    var mainItem = bundle.querySelector('[data-mp-bundle-item].is-main');

    /* Discount tiers come from the block settings so they can be retuned in
       the theme editor without a deploy. The percentages here are display
       only — the matching discount code is what actually applies them, so a
       tier without a code shows no saving rather than a promise we cannot keep. */
    function tier(count) {
      var percent = Number(bundle.getAttribute('data-bundle-discount-' + count)) || 0;
      var code = (bundle.getAttribute('data-bundle-code-' + count) || '').trim();
      return percent > 0 && code ? { percent: percent, code: code } : null;
    }

    /* A row whose product and pinned options match the variant on screen would
       add the same thing twice, so it steps aside. Switching Type on the picker
       swaps which row hides, and the set always stays complete. */
    function hiddenAsDuplicate(item) {
      if (item === mainItem || !mainItem) return false;
      var pinned = item.getAttribute('data-bundle-pinned');
      if (pinned === null) return false;
      return item.getAttribute('data-bundle-product-id') === mainItem.getAttribute('data-bundle-product-id') &&
        pinned === mainItem.getAttribute('data-bundle-pinned');
    }

    function visibleItems() {
      return items.filter(function (item) {
        var duplicate = hiddenAsDuplicate(item);
        item.hidden = duplicate;
        return !duplicate;
      });
    }

    function selectedItems() {
      return visibleItems().filter(function (item) {
        var input = item.querySelector('.mp-product-bundle__input');
        return !input || input.checked;
      });
    }

    /* Every row shows what the bundle takes off its own price. A shopper who
       has seen the coin's product page needs to read, on this row, that the
       same pack costs less here than it does over there. */
    function paintRow(item, percent) {
      var base = Number(item.getAttribute('data-bundle-price')) || 0;
      var input = item.querySelector('.mp-product-bundle__input');
      var active = percent > 0 && (!input || input.checked);
      var off = active ? Math.round((base * percent) / 100) : 0;

      var priceNode = item.querySelector('.mp-product-bundle__item-price');
      if (priceNode) priceNode.textContent = formatMoney(base - off);

      var wasNode = item.querySelector('[data-mp-bundle-item-was]');
      if (wasNode) {
        wasNode.textContent = off ? formatMoney(base) : '';
        wasNode.hidden = !off;
      }

      var savingNode = item.querySelector('[data-mp-bundle-item-saving]');
      if (savingNode) {
        savingNode.textContent = off ? formatMoney(off) + ' less than buying it alone' : '';
        savingNode.hidden = !off;
      }

      return off;
    }

    function sync() {
      /* A bundle of one is just the product, so the block stands down. */
      bundle.hidden = visibleItems().length < 2;

      var selected = selectedItems();
      var sum = selected.reduce(function (memo, item) {
        return memo + (Number(item.getAttribute('data-bundle-price')) || 0);
      }, 0);

      items.forEach(function (item) {
        var input = item.querySelector('.mp-product-bundle__input');
        item.classList.toggle('is-selected', !input || input.checked);
      });

      var deal = tier(selected.length);

      /* Add the rows' own discounts up rather than taking a percentage of the
         sum, so the total always equals what the rows above it say. */
      var discount = 0;
      items.forEach(function (item) {
        var off = paintRow(item, deal ? deal.percent : 0);
        if (selected.indexOf(item) > -1) discount += off;
      });

      if (total) total.textContent = formatMoney(sum - discount);

      if (wasPrice) {
        wasPrice.textContent = discount ? formatMoney(sum) : '';
        wasPrice.hidden = !discount;
      }

      if (saving) {
        saving.textContent = discount
          ? 'Save ' + formatMoney(discount) + ' (' + deal.percent + '% off) with code ' + deal.code
          : '';
        saving.hidden = !discount;
      }

      if (addButton) {
        addButton.textContent = selected.length > 1
          ? addLabel + ' · ' + selected.length + ' items'
          : addLabel;
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', sync);
    });

    /* Only the last option is shopper-editable per row; the rest were pinned by
       the variant chosen in the metafield. Sizes are priced individually here —
       a 6XL hoodie costs $17 more than the S — so the row has to re-price. */
    var sizeSelects = Array.from(bundle.querySelectorAll('[data-mp-bundle-size]'));
    sizeSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        select.dataset.touched = 'true';
        applySizeSelection(select);
        sync();
      });
    });

    function applySizeSelection(select) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var item = select.closest('[data-mp-bundle-item]');
      if (!item) return;

      item.setAttribute('data-bundle-variant-id', option.value);
      item.setAttribute('data-bundle-price', option.getAttribute('data-price'));

      /* Packs of 1 and 7 photograph differently, so the zoom has to follow the
         chosen variant rather than the one the metafield happened to name. */
      var image = option.getAttribute('data-image');
      if (image) item.setAttribute('data-bundle-image', image);

      var thumb = item.querySelector('.mp-product-bundle__media img');
      if (thumb && image) {
        thumb.src = image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=320';
        thumb.removeAttribute('srcset');
      }
      /* paintRow owns the visible price — it is the only place that knows
         whether a tier is live. */
    }

    /* Follow the shopper's size across the whole set: pick L above and the
       hoodie row follows, unless they have already set that row themselves. */
    function followMainOption(optionValue) {
      if (!optionValue) return;
      sizeSelects.forEach(function (select) {
        if (select.dataset.touched === 'true') return;
        var match = Array.from(select.options).filter(function (option) {
          return option.getAttribute('data-option') === optionValue;
        })[0];
        if (!match || match.value === select.value) return;
        select.value = match.value;
        applySizeSelection(select);
      });
    }

    /* Dawn re-renders the price and variant picker on every option change but
       leaves this block untouched, so the main item would keep the price of the
       variant that happened to be selected on page load. Products here are
       priced per variant (a hoodie 6XL costs far more than an 11oz mug), so
       read the freshly rendered variant back into the bundle. */
    var productInfo = bundle.closest('product-info');
    if (productInfo && mainItem) {
      var lastVariantId = mainItem.getAttribute('data-bundle-variant-id');
      new MutationObserver(function () {
        var node = productInfo.querySelector('variant-selects [data-selected-variant]');
        if (!node) return;

        var variant;
        try {
          variant = JSON.parse(node.textContent);
        } catch (error) {
          return;
        }
        if (!variant || !variant.id || String(variant.id) === String(lastVariantId)) return;

        lastVariantId = String(variant.id);
        var options = Array.isArray(variant.options) ? variant.options : [];

        mainItem.setAttribute('data-bundle-variant-id', variant.id);
        mainItem.setAttribute('data-bundle-price', variant.price);
        if (options.length > 1) {
          mainItem.setAttribute('data-bundle-pinned', options.slice(0, -1).join('||') + '||');
        }

        var priceNode = mainItem.querySelector('.mp-product-bundle__item-price');
        if (priceNode) priceNode.textContent = formatMoney(variant.price);

        var lastOption = options[options.length - 1] || '';
        mainItem.setAttribute('data-bundle-last-option', lastOption);

        /* The main row is named by its pinned options, exactly like the rows
           below it, so switching Type renames it from Cap to Hoodie. */
        var titleNode = mainItem.querySelector('[data-mp-bundle-main-title]');
        if (titleNode && options.length > 1) {
          titleNode.textContent = options.slice(0, -1).join(' / ');
        }

        var optionNode = mainItem.querySelector('[data-mp-bundle-main-option]');
        if (optionNode) optionNode.textContent = lastOption || variant.title || '';

        /* Dawn swaps the gallery but not this thumbnail, so a Hoodie row would
           keep showing the Cap. Variants carry their own featured image. */
        var mediaNode = mainItem.querySelector('[data-mp-bundle-main-media]');
        var variantImage = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image);
        var img = mediaNode && mediaNode.querySelector('img');
        if (img && variantImage && variantImage.src) {
          var src = variantImage.src;
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
          img.removeAttribute('srcset');
          img.alt = titleNode ? titleNode.textContent : img.alt;
          mainItem.setAttribute('data-bundle-image', src);
        }
        if (titleNode) mainItem.setAttribute('data-bundle-title', titleNode.textContent);

        followMainOption(lastOption);
        sync();
      }).observe(productInfo, { childList: true, subtree: true });
    }

    /* The protection toggle lives outside this block and rides along with the
       main add-to-cart form. Adding the bundle has to carry it too, or a
       shopper who left the toggle on ends up without the cover they think
       they bought. Mirrors the payload built in product-form.js. */
    function protectionVariantId() {
      var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
      if (!form) return null;
      var input = form.querySelector('[data-mp-protection-property]:not(:disabled)');
      if (!input) return null;
      var id = Number(input.getAttribute('data-mp-protection-variant-id'));
      return id ? id : null;
    }

    /* Protection is one flat fee, not a per-item charge, so adding it again
       when the shopper already has it would bump the line quantity and bill
       them twice. Look before adding. */
    function protectionToAdd(root) {
      var id = protectionVariantId();
      if (!id) return Promise.resolve(null);

      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var present = (cart.items || []).some(function (line) {
            return Number(line.variant_id) === id;
          });
          return present ? null : id;
        })
        .catch(function () { return id; });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var selected = selectedItems();
        var cartItems = selected.map(function (item) {
          return {
            id: Number(item.getAttribute('data-bundle-variant-id')),
            quantity: 1
          };
        }).filter(function (item) { return item.id; });

        if (!cartItems.length) return;
        addButton.classList.add('is-loading');
        addButton.disabled = true;

        var deal = tier(selected.length);
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

        protectionToAdd(root)
          .then(function (protectionId) {
            if (protectionId) {
              cartItems.push({
                id: protectionId,
                quantity: 1,
                properties: { _source: 'Shipping protection', _discount_exempt: 'true' }
              });
            }

            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: cartItems })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Bundle add failed');
            return response.json();
          })
          .then(function () {
            /* /discount/CODE puts the code on the session, then hands the
               shopper to the cart with it already applied — no copy and paste. */
            window.location.href = deal
              ? root + 'discount/' + encodeURIComponent(deal.code) + '?redirect=' + encodeURIComponent(cartUrl)
              : cartUrl;
          })
          .catch(function () {
            addButton.classList.remove('is-loading');
            addButton.disabled = false;
            addButton.textContent = 'Try again';
            window.setTimeout(sync, 1400);
          });
      });
    }

    /* Tapping a row shows the variant's photo without leaving the page —
       following a link to the coin's own product page would drop the bundle. */
    var popup = bundle.querySelector('[data-mp-bundle-popup]');
    if (popup) {
      var popupImg = popup.querySelector('[data-mp-bundle-popup-img]');
      var popupTitle = popup.querySelector('[data-mp-bundle-popup-title]');
      var popupPrice = popup.querySelector('[data-mp-bundle-popup-price]');

      function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
      }

      function openPopup(item) {
        var image = item.getAttribute('data-bundle-image');
        if (!image) return;

        popupImg.src = image;
        popupImg.alt = item.getAttribute('data-bundle-title') || '';
        popupTitle.textContent = item.getAttribute('data-bundle-title') || '';

        var option = item.querySelector('[data-mp-bundle-size]');
        var optionLabel = option
          ? option.options[option.selectedIndex].getAttribute('data-option')
          : (item.querySelector('.mp-product-bundle__item-option') || {}).textContent;
        var priceNode = item.querySelector('.mp-product-bundle__item-price');
        popupPrice.textContent = [
          (optionLabel || '').trim(),
          priceNode ? priceNode.textContent.trim() : ''
        ].filter(Boolean).join(' · ');

        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
      }

      popup.querySelectorAll('[data-mp-bundle-popup-close]').forEach(function (node) {
        node.addEventListener('click', closePopup);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePopup();
      });

      items.forEach(function (item) {
        item.addEventListener('click', function (event) {
          /* The dropdown and the include/exclude checkbox are controls in their
             own right — clicking them must not also open a lightbox. */
          if (event.target.closest('[data-mp-bundle-size], .mp-product-bundle__toggle')) return;
          openPopup(item);
        });
      });
    }

    if (mainItem) followMainOption(mainItem.getAttribute('data-bundle-last-option'));
    sync();
  });

  document.querySelectorAll('[data-mp-addon-toggle]').forEach(function (container) {
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (!form) return;
    var checkbox = container.querySelector('[data-mp-addon-checkbox]');
    if (!checkbox) return;
    var variantId = container.getAttribute('data-mp-addon-variant-id') || '';

    var input = form.querySelector('[data-mp-addon-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      form.appendChild(input);
    }
    input.setAttribute('data-mp-addon-property', '');
    input.setAttribute('data-mp-addon-variant-id', variantId);

    var storageKey = 'mp_addon_off_' + variantId;
    var defaultActive = sessionStorage.getItem(storageKey) !== '1';

    checkbox.checked = defaultActive;
    input.disabled = !defaultActive;
    container.classList.toggle('is-active', defaultActive);

    checkbox.addEventListener('change', function () {
      var active = checkbox.checked;
      input.disabled = !active;
      container.classList.toggle('is-active', active);
      if (active) {
        sessionStorage.removeItem(storageKey);
      } else {
        sessionStorage.setItem(storageKey, '1');
      }
    });
  });

  (function () {
    var popup = document.querySelector('.mp-addon-popup');
    if (!popup) return;
    var popupImg = popup.querySelector('.mp-addon-popup__img');
    var popupTitle = popup.querySelector('.mp-addon-popup__title');
    var popupPrice = popup.querySelector('.mp-addon-popup__price');

    function openPopup(src, alt, title, price) {
      popupImg.src = src;
      popupImg.alt = alt;
      popupTitle.textContent = title;
      popupPrice.textContent = price;
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    popup.querySelectorAll('[data-mp-addon-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    document.querySelectorAll('[data-mp-addon-img-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopup(btn.dataset.imgSrc, btn.dataset.imgAlt, btn.dataset.imgTitle, btn.dataset.imgPrice);
      });
    });
  })();

  document.querySelectorAll('[data-mp-protection-toggle]').forEach(function (button) {
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (!form) return;
    var switchButton = button.querySelector('[data-mp-protection-switch]');

    var input = form.querySelector('[data-mp-protection-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      form.appendChild(input);
    }
    input.setAttribute('data-mp-protection-property', '');
    input.setAttribute('data-mp-protection-variant-id', button.getAttribute('data-mp-protection-variant-id') || '');

    function sync(active) {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (switchButton) switchButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      input.disabled = !active;
      if (active) {
        sessionStorage.removeItem('mp_prot_off');
      } else {
        sessionStorage.setItem('mp_prot_off', '1');
      }
    }

    button.addEventListener('click', function (event) {
      if (!event.target.closest('[data-mp-protection-switch]')) return;
      sync(button.getAttribute('aria-pressed') !== 'true');
    });

    // Default active unless user previously unchecked in this session
    var defaultActive = button.classList.contains('is-active') && sessionStorage.getItem('mp_prot_off') !== '1';
    sync(defaultActive);
  });

  document.addEventListener('click', function (event) {
    var finalButton = event.target.closest('[data-mp-final-add]');
    if (!finalButton) return;
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    var submit = form ? form.querySelector('[type="submit"]') : document.querySelector('.mp-product-page .product-form__submit');
    if (submit) submit.click();
  });

  document.querySelectorAll('[data-mp-copy-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-mp-copy-code') || '';
      var original = button.textContent;

      function markCopied() {
        button.classList.add('is-copied');
        button.textContent = 'Copied';
        window.setTimeout(function () {
          button.classList.remove('is-copied');
          button.textContent = original;
        }, 1400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
      } else {
        markCopied();
      }
    });
  });

  document.querySelectorAll('[data-mp-copy-link]').forEach(function (button) {
    button.addEventListener('click', function () {
      var link = button.getAttribute('data-mp-copy-link') || window.location.href;

      function markCopied() {
        button.classList.add('is-copied');
        window.setTimeout(function () {
          button.classList.remove('is-copied');
        }, 1400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(markCopied).catch(markCopied);
      } else {
        markCopied();
      }
    });
  });

  document.querySelectorAll('.product__media-wrapper slider-component').forEach(function (sliderComponent) {
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var slides = Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]'));
    var dots = Array.from(sliderComponent.querySelectorAll('[data-mp-media-dot]'));
    if (!slider || !slides.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('slider-counter__link--active', dotIndex === index);
        if (dotIndex === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.getAttribute('data-mp-media-dot')) || 0;
        var slide = slides[index];
        if (!slide) return;
        slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var currentIndex = 0;
        var smallestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slider.scrollLeft - slide.offsetLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }
        });
        setActive(currentIndex);
      });
    }, { passive: true });
  });

  // Sticky ATC bar: slide up when buy-box scrolls off screen, hide when visible
  var stickyAtc = document.querySelector('.mp-product-sticky-atc');
  if (stickyAtc && 'IntersectionObserver' in window) {
    var cartNotification = document.getElementById('cart-notification');
    function syncCartPopupState() {
      stickyAtc.classList.toggle('is-cart-popup-open', Boolean(cartNotification && cartNotification.classList.contains('active')));
    }

    function getBuyBox() {
      // Prefer the add-to-cart button that is actually visible. Customily hides
      // the native .product-form__submit and renders its own (#customily-cart-btn),
      // so observing the first match blindly can mean observing a display:none node.
      var candidates = document.querySelectorAll('.mp-product-page .product-form__submit, .mp-product-page #customily-cart-btn');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null) return candidates[i];
      }
      return candidates[0] || document.querySelector('.mp-product-page .product__info-wrapper');
    }

    var atcObserver = null;
    var observedBuyBox = null;

    function attachAtcObserver() {
      var buyBox = getBuyBox();
      if (!buyBox || buyBox === observedBuyBox) return;
      if (atcObserver) atcObserver.disconnect();
      observedBuyBox = buyBox;
      atcObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Reveal only once the buy box has scrolled ABOVE the top of the viewport
        // (the user has passed it) — NOT while it is still below the fold at page
        // load. Otherwise the sticky bar shows immediately on load (mobile).
        var passedBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', passedBuyBox);
        syncCartPopupState();
      }, { threshold: 0 });
      atcObserver.observe(buyBox);
    }

    attachAtcObserver();

    /* Personalization apps (e.g. Customily) can re-render the add-to-cart
       button after page load, detaching the node we were observing. Watch
       for that and re-attach to the live button so the sticky bar doesn't
       end up stuck visible alongside the app's own button. */
    var formWatchTarget = document.querySelector('.mp-product-page .product-form') || document.querySelector('.mp-product-page .product__info-container');
    if (formWatchTarget && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!observedBuyBox || !observedBuyBox.isConnected) {
          attachAtcObserver();
        }
      }).observe(formWatchTarget, { childList: true, subtree: true });
    }

    if (cartNotification && 'MutationObserver' in window) {
      new MutationObserver(syncCartPopupState).observe(cartNotification, { attributes: true, attributeFilter: ['class'] });
    }
    syncCartPopupState();
  }

  document.querySelectorAll('.mp-product-page .product__accordion details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animation;

    summary.addEventListener('click', function (event) {
      if (prefersReducedMotion) return;
      event.preventDefault();

      if (animation) animation.cancel();

      if (details.open) {
        var startHeight = content.offsetHeight;
        animation = content.animate(
          [
            { height: startHeight + 'px', opacity: 1 },
            { height: 0, opacity: 0 }
          ],
          { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)' }
        );
        animation.onfinish = function () {
          details.open = false;
          content.style.height = '';
          content.style.opacity = '';
        };
      } else {
        details.open = true;
        content.style.height = 'auto';
        var endHeight = content.offsetHeight;
        animation = content.animate(
          [
            { height: 0, opacity: 0 },
            { height: endHeight + 'px', opacity: 1 }
          ],
          { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' }
        );
        animation.onfinish = function () {
          content.style.height = '';
          content.style.opacity = '';
        };
      }
    });
  });
  document.querySelectorAll('[data-mp-demand]').forEach(function (el) {
    var productId = parseInt(el.getAttribute('data-mp-demand'), 10) || 0;
    var dayNum = Math.floor(Date.now() / 86400000);
    var seed = productId * 7 + dayNum * 13;
    var x = Math.sin(seed + 1) * 10000;
    var r = x - Math.floor(x);
    var count = 14 + Math.floor(r * 54);
    var countEl = el.querySelector('.mp-demand-count');
    if (countEl) countEl.textContent = count;
  });

  /* POD: prevent Customily variant events from showing sold-out state */
  (function () {
    var podEl = document.querySelector('product-info[data-pod]');
    if (!podEl) return;

    function clearSoldOut() {
      /* restore submit button */
      var btn = podEl.querySelector('[type="submit"][name="add"]');
      if (btn && btn.hasAttribute('disabled')) {
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span:first-child');
        if (span && (span.textContent || '').trim() !== '') {
          span.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        }
      }
      /* remove sold-out CSS class from price elements */
      podEl.querySelectorAll('.price--sold-out').forEach(function (el) {
        el.classList.remove('price--sold-out');
      });
      /* restore price if setUnavailable() hid it */
      podEl.querySelectorAll('[id^="price-"].hidden').forEach(function (el) {
        el.classList.remove('hidden');
      });
    }

    clearSoldOut();

    /* watch for Dawn / Customily re-disabling the button */
    var btn = podEl.querySelector('[type="submit"][name="add"]');
    if (btn) {
      new MutationObserver(clearSoldOut).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    /* watch for price--sold-out being re-added */
    podEl.querySelectorAll('.price').forEach(function (el) {
      new MutationObserver(clearSoldOut).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  })();

})();

// ── Modal pinch-to-zoom (mobile) ──────────────────────────────────────────────
(function () {
  if (window.matchMedia('(pointer: coarse)').matches === false) return;

  customElements.whenDefined('product-modal').then(function () {
    var modal = document.querySelector('product-modal.product-media-modal');
    if (!modal || modal._mpz) return;
    modal._mpz = true;

    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var sc = 1, sc0 = 1, d0 = 1;

    function hyp(ta) {
      var dx = ta[0].clientX - ta[1].clientX;
      var dy = ta[0].clientY - ta[1].clientY;
      return Math.sqrt(dx * dx + dy * dy) || 1;
    }

    function activeEl() {
      return modal.querySelector('[data-media-id].active');
    }

    content.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        d0 = hyp(e.touches);
        sc0 = sc;
      }
    }, { passive: true });

    content.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2) return;
      e.preventDefault();
      var t = activeEl();
      if (!t) return;
      sc = Math.max(1, Math.min(4, sc0 * hyp(e.touches) / d0));
      t.style.transformOrigin = '50% 50%';
      t.style.transform = 'scale(' + sc + ')';
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (e.touches.length > 0) return;
      if (sc < 1.08) {
        var t = activeEl();
        sc = 1;
        if (t) {
          t.style.transition = 'transform 0.22s ease';
          t.style.transform = 'scale(1)';
          setTimeout(function () { t.style.transition = ''; }, 240);
        }
      }
    }, { passive: true });

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        var t = activeEl();
        if (t) { t.style.transform = ''; t.style.transition = ''; }
        sc = 1;
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

  /* Hydrate shipping_tab accordion dates with fresh JS values on every open.
     Liquid server-render could be stale if Shopify CDN cached the page. */
  document.querySelectorAll('[data-mp-ship-tab]').forEach(function (details) {
    var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function fmtD(date) { return mo[date.getMonth()] + ' ' + date.getDate(); }
    function plusD(n) { var r = new Date(); r.setDate(r.getDate() + n); return r; }

    function hydrate() {
      var prodMin = parseInt(details.getAttribute('data-mp-ship-prod-min'), 10) || 3;
      var prodMax = parseInt(details.getAttribute('data-mp-ship-prod-max'), 10) || 5;
      var p = details.querySelector('[data-mp-ship-placed]');
      var s = details.querySelector('[data-mp-ship-ships]');
      var d = details.querySelector('[data-mp-ship-delivered]');
      if (p) p.textContent = fmtD(new Date());
      if (s) s.textContent = fmtD(plusD(prodMin)) + '–' + fmtD(plusD(prodMax));
      if (d) d.textContent = fmtD(plusD(8)) + '–' + fmtD(plusD(10));
    }

    hydrate();
    details.addEventListener('toggle', function () { if (details.open) hydrate(); });
  });
})();
